import { render, staticRenderFns } from "./ResetFiltersButton.vue?vue&type=template&id=416f472d"
import script from "./ResetFiltersButton.vue?vue&type=script&lang=ts"
export * from "./ResetFiltersButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports